import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Kalkulator from "@/pages/Kalkulator";
import Bep from "@/pages/Bep";
import Resep from "@/pages/Resep";
import Kasir from "@/pages/Kasir";
import Laporan from "@/pages/Laporan";
import Admin from "@/pages/Admin";
import ChangePassword from "@/pages/ChangePassword";
import PasswordGate from "@/components/PasswordGate";

function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <PasswordGate />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="kalkulator" element={<Kalkulator />} />
        <Route path="bep" element={<Bep />} />
        <Route path="resep" element={<Resep />} />
        <Route path="kasir" element={<Kasir />} />
        <Route path="laporan" element={<Laporan />} />
        <Route path="ganti-sandi" element={<ChangePassword />} />
        <Route
          path="admin"
          element={
            <ProtectedRoute adminOnly>
              <Admin />
            </ProtectedRoute>
          }
        />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
